// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3e2GI","fileBtn":"File_fileBtn__2ZI4T","closeBtn":"File_closeBtn__2YhqB","fileSelected":"File_fileSelected__3LWM2","disabled":"File_disabled__ufTSj"};